import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import { NOT_STARTED, IN_PROGRESS, COMPLETE, ERROR } from '@/lib/constants/actionStatuses'
import { PATH_DEAL_ASSIGNMENT } from '@/lib/constants/api'
import getDealAssignmentModel from './models/dealAssignment'
import updateStatus from '@/store/helpers/updateStatus'
import { notifySuccess, notifyError } from '@/lib/notifications'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'

const dealAssignment = {
  namespaced: true,
  state: {
    ...getDealAssignmentModel()
  },
  getters: {
    getField,
    getDealAssignmentObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    updateStatus,
    clearDealAssignment: (state) => {
      state.id = null
      state.dealId = null
      state.employeeTypeId = null
      state.corporateName = null
      state.ein = null
      state.contractTypeId = null
      state.lengthOfContract = null
      state.conversionFee = null
      state.payFrequencyId = null
      state.payRateTypeId = null
      state.payRate = null
      state.billRateTypeId = null
      state.billRate = null
      state.overtimeEligible = null
      state.startAt = null
      state.endAt = null
      state.jobTitle = null
      state.permPlacementDate = null
      state.permPlacementSalary = null
      state.permPlacementFee = null
      state.permPlacementFeeTypeId = null
      state.permPlacementInvoiceDate = null
      state.permPlacementInvoiceDueDate = null
      state.commissions = []
      state.expenses = []
      state.workedHoursAverage = null
      state.overtimeThreshold = null
      state.overtimeRate = null
      state.timeSheetType = 2
      state.clockIPAddress = null
    },
    setDealAssignment: (state, assignment) => {
      state.id = assignment.id
      state.dealId = assignment.dealId
      state.employeeTypeId = assignment.employeeTypeId
      state.corporateName = assignment.corporateName
      state.ein = assignment.ein
      state.contractTypeId = assignment.contractTypeId
      state.lengthOfContract = assignment.lengthOfContract
      state.conversionFee = assignment.conversionFee
      state.payFrequencyId = assignment.payFrequencyId
      state.payRateTypeId = assignment.payRateTypeId
      state.payRate = assignment.payRate
      state.billRateTypeId = assignment.billRateTypeId
      state.billRate = assignment.billRate
      state.overtimeEligible = assignment.overtimeEligible
      state.startAt = assignment.startAt
      state.endAt = assignment.endAt
      state.jobTitle = assignment.jobTitle
      state.permPlacementDate = assignment.permPlacementDate
      state.permPlacementSalary = assignment.permPlacementSalary
      state.permPlacementFee = assignment.permPlacementFee
      state.permPlacementFeeTypeId = assignment.permPlacementFeeTypeId
      state.permPlacementInvoiceDate = assignment.permPlacementInvoiceDate
      state.permPlacementInvoiceDueDate = assignment.permPlacementInvoiceDueDate
      state.commissions = assignment.commissions
      state.expenses = assignment.expenses
      state.workedHoursAverage = assignment.workedHoursAverage
      state.overtimeThreshold = assignment.overtimeThreshold
      state.overtimeRate = assignment.overtimeRate
      state.timeSheetType = assignment.timeSheetType
      state.clockIPAddress = assignment.clockIPAddress
    }
  },
  actions: {
    save ({ state }) {
      return api.doPost({ path: PATH_DEAL_ASSIGNMENT, data: state })
    },
    update ({ state }) {
      return api.doPut({ path: PATH_DEAL_ASSIGNMENT, data: state })
    },
    getDealAssignment: ({ commit, dispatch }, { dealId }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting contract details, please wait...' })
      commit('clearDealAssignment')
      return api.doGet({ path: PATH_DEAL_ASSIGNMENT, parameters: { dealId } })
        .then(json => json.data)
        .then(assignment => {
          commit('updateStatus', { status: COMPLETE })
          commit('setDealAssignment', assignment)
          hideProgressModal({ dispatch })

          return assignment
        }).catch((error) => {
          hideProgressModal({ dispatch })
          commit('updateStatus', { status: ERROR, error })
        })
    },
    saveDealAssignment: ({ state, commit, dispatch }) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving contract details, please wait...' })

      const actionName = state.id ? 'update' : 'save'

      return dispatch(actionName).then(response => {
        commit('updateStatus', { status: COMPLETE })

        if (!response.data) {
          throw new Error('Unable to save contract details. Check required fields.')
        }

        hideProgressModal({ dispatch })
        notifySuccess(dispatch, 'Contract details saved')
        commit('setDealAssignment', response.data)
        return response
      }).catch((error) => {
        commit('updateStatus', { status: ERROR, error })
        hideProgressModal({ dispatch })
        notifyError(dispatch, 'Unable to save contract details. Try again later')

        throw error
      })
    },
    clearDealAssignment: ({ commit }) => {
      commit('clearDealAssignment')
      return commit('updateStatus', { status: NOT_STARTED })
    }
  }
}

export default dealAssignment
